<footer class="bg-dark text-white"> 
    <div class="container d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
        <div>
            <span class="mb-3 mb-md-0">© 2026 
                <a class="navbar-brand" routerLink="/">
                    <img
                        src="/logo.png"
                        alt="Daily Dev Resource"
                        height="40"
                        class="logo rounded-2"
                    />
                </a>
            </span> 
        </div> 
        <div class="d-flex gap-2 flex-wrap">
            <a
                href="https://github.com/ishwar-panchariya/developer-resources"
                target="_blank"
                class="btn btn-primary btn-sm"
            >
                <i class="bi bi-github me-1"></i>
                View Repository
            </a>

            <a
                href="https://github.com/ishwar-panchariya/developer-resources/blob/master/CONTRIBUTING.md"
                target="_blank"
                class="btn btn-light btn-sm"
            >
                Contribution Guide
            </a>
        </div>
    </div>
</footer>